import React from 'react'
import { sample } from 'lodash'

import "./AgendaItem.less"

function warningTime(time) {
  if (time >= 3600) return '#ff6d6d'
  else if (time >= 1800) return '#ffff50'
  else return 'white'
}

const travelEmojis = {
  transit: () => "🚍",
  walking: () => sample(["️👫", "👭", "👬"]),
  driving: () => "🚘",
  RAIL: () => "🚅",
  airplane: () => "✈️",
  BUS: () => "🚌",
} 

const departureStations = {
  RAIL: "🚉",
  airplane: "🛫",
  BUS: '🚏'
}

const arrivalStations = {
  RAIL: "🚉",
  airplane: "🛬",
  BUS: '🚏'
}

const Times = React.memo(props => {
  const routeTimes = props.routeTimes ?  JSON.parse(props.routeTimes) : null
  return (
    <div>
      <div className='travels_container'>
        {routeTimes 
                    && routeTimes.map((rt, i) => {
                      const { recommendedTransportation, durationTime, distance, duration, fromHotel, fromStation, transportType, toStation, toHotel, } = rt
                      return (
                        <React.Fragment key={rt.id}>
                          {i > 0 && <img classNam e="arrow" src="/static/img/right_arrow.svg"/>}
                          <div className="travel" style={{ backgroundColor: recommendedTransportation == 'walking' ? warningTime(durationTime) : 'white' }}>
                            <div className="data">
                              {recommendedTransportation == 'walking' && <div className="distance">{distance}</div>}
                              <div className="duration">{duration}</div>
                            </div>
                            <div className="icons">
                              {fromHotel && <div>🏨</div>}
                              {fromStation &&  <div>{arrivalStations[fromStation]}</div>}
                              <div>{(travelEmojis[transportType] && travelEmojis[transportType]()) || (travelEmojis[recommendedTransportation] && travelEmojis[recommendedTransportation]())}</div>
                              {(toStation || toHotel) && <img className="straight" src="/static/img/straight_arrow.svg"/>}
                              {toStation && <div>{departureStations[toStation]}</div>}
                              {toHotel && <div>🏨</div>}
                              {i == routeTimes.length - 1 && !toStation && !toHotel && <img className="arrow" src="/static/img/round_arrow.svg"/>}
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })
        }
      </div>
    </div>
  )
})
export default Times